import { cn } from "@/lib/utils";
import { Textarea } from "../ui/textarea";

interface TextboxProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export function TextboxPrimary({ className, ...props }: TextboxProps) {
  return (
    <Textarea
      className={cn(
        "bg-transparent dark:bg-transparent outline-none border border-border shadow-none focus-visible:ring-0 h-10",
        className,
      )}
      {...props}
    />
  );
}
